import React from "react";
import { Box, CssBaseline } from "@mui/material";
import { Outlet } from "react-router-dom";

import Header from "../components/Header/Header";
import SideBar from "../components/Dashboard/SideBar";
import OpenModal from "../components/PopUpModal/OpenModal";

import Ringtone from "../assets/sounds/ringtone.mp3";

function DashboardLayout() {
  return (
    <>
      <OpenModal />
      <Box sx={{ display: "flex", minHeight: "100vh", backgroundColor: "#eae9ff" }}>
        {/* Sidebar */}
        <Box
          component="nav"
          sx={{
            width: { sm: 240 }, // Sidebar width
            flexShrink: { sm: 0 },
            backgroundColor: "#fff",
            borderRight: "1px solid #d9d9d9",
            zIndex: 9,
          }}
        >
          <SideBar />
        </Box>

        {/* Main Content Area */}
        <Box sx={{ display: "flex", flexDirection: "column", flexGrow: 1, overflow: "auto" }}>
          {/* Header */}
          <Header />

          {/* Main Content */}
          <Box
            component="main"
            sx={{
              position: "relative",
              flexGrow: 1,
              backgroundColor: "#F2F2F2",
            }}
          >
            {/* use call ringtone play  */}

            <audio id="mediaElement" style={{ display: "none" }} />
            <audio id="connectingRingTone" src={Ringtone} style={{ display: "none" }} loop />
            <audio
              id="InComingConnectingRingTone"
              src={Ringtone}
              style={{ display: "none" }}
              loop
            />

            <Outlet />
          </Box>
        </Box>
        <CssBaseline />
      </Box>
    </>
  );
}

export default DashboardLayout;
